import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { PostHogProvider } from '@posthog/react' 
import { I18nextProvider } from "react-i18next";
import 'antd/dist/antd.min.css';

import Router from "./router";
import i18n from "./translation";

const App = () => (
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <Router />
    </I18nextProvider>
  </BrowserRouter>
);

const posthogApiKey = process.env.REACT_APP_POSTHOG_KEY;

const RootApp = posthogApiKey ? (
  <PostHogProvider
    apiKey={posthogApiKey}
    options={{
      api_host: process.env.REACT_APP_POSTHOG_HOST,
      defaults: '2025-05-24',
      capture_exceptions: true,
      debug: process.env.NODE_ENV === "development",
    }}
  >
    <App />
  </PostHogProvider>
) : (
  <App />
);

ReactDOM.render(RootApp, document.getElementById("root"));
